export default "__VITE_ASSET__CsIH8T1z__"